import React, { useState } from 'react';
import styles from './CommentActions.module.scss';
import { CustomButton } from '../../Button/Button';
import Emoji from '../../Emoji/Emoji';
import { useTranslation } from 'react-i18next';

const NameField = ({ cachedReaction, setUsername, setShowNameInputField }) => {
  const [userInput, setUserInput] = useState();

  const { t } = useTranslation();

  const handleSubmitReaction = () => {
    setUsername(userInput);
    localStorage.setItem('commenterName', userInput);
  };

  const handleCancel = () => {
    setUserInput(null);
    setUsername(null);
    setShowNameInputField(false);
  };

  const handleChangeInput = e => {
    setUserInput(e.target.value);
  };

  return (
    <div className={styles.nameFieldContainer} style={{ marginBottom: '20px' }}>
      <>
        <div className={styles.nameField}>
          <Emoji unicode={cachedReaction.unicode} />
          <input
            placeholder="Your name"
            className={styles.replyNameField}
            type="text"
            name="username"
            value={userInput}
            onChange={handleChangeInput}
            autoFocus={true}
          />
        </div>
        <div className={styles.actionButtonsContainer}>
          <CustomButton label="Cancel" variant="secondary" className={`${styles.btn} ${styles.whiteBtn} `} onClick={handleCancel} />
          <CustomButton
            label={t('general.save')}
            variant="primary"
            customStyles={!userInput ? { opacity: ' 0.3' } : {}}
            disabled={!userInput}
            className={`${styles.btn} ${styles.primaryBtn} `}
            onClick={handleSubmitReaction}
          />
        </div>
      </>
    </div>
  );
};

export default NameField;
